import { render, staticRenderFns } from "./SettingWard.vue?vue&type=template&id=1fefec10&"
import script from "./SettingWard.vue?vue&type=script&lang=js&"
export * from "./SettingWard.vue?vue&type=script&lang=js&"
import style0 from "./SettingWard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports